<div class="dashboard-container">
  <!-- Card del Gráfico de Tareas por Estado -->
  <mat-card appearance="outlined" class="chart-card">
    <ngx-spinner
      [zIndex]="100"
      name="spCantidadPorEstado"
      bdColor="rgba(255,255,255,0.8)"
      size="default"
      color="var(--primary-color)"
      type="ball-atom"
      [fullScreen]="false"
    ></ngx-spinner>

    <mat-card-header class="card-header">
      <div class="header-content">
        <mat-icon class="header-icon">pie_chart</mat-icon>
        <div class="header-text">
          <mat-card-title>Tareas por Estado</mat-card-title>
          <mat-card-subtitle>Distribución de tareas según su estado actual</mat-card-subtitle>
        </div>
      </div>
    </mat-card-header>

    <mat-divider></mat-divider>

    <mat-card-content class="chart-content">
      <div class="chart-container" *ngIf="cantidadPorEstadoDto.length > 0">
        <canvas #pieChart></canvas>
      </div>

      <div class="chart-summary">
        <div class="summary-item">
          <span class="summary-label">Total de tareas:</span>
          <span class="summary-value">{{ calcularCantidadTotalPorEstado() }}</span>
        </div>
      </div>

      <div class="no-data" *ngIf="cantidadPorEstadoDto.length === 0">
        <mat-icon>analytics</mat-icon>
        <span>No hay datos para mostrar</span>
      </div>
    </mat-card-content>

    <mat-card-actions>
      <button mat-button [routerLink]="['/tareas']">
        <mat-icon>list</mat-icon>
        Ver listado completo
      </button>
    </mat-card-actions>
  </mat-card>

  <!-- Card del Listado de Tareas Mejorado -->
  <mat-card appearance="outlined" class="table-card">
    <mat-card-header class="card-header">
      <div class="header-content">
        <mat-icon class="header-icon">assignment</mat-icon>
        <div class="header-text">
          <mat-card-title>Tareas Recientes</mat-card-title>
          <mat-card-subtitle>Últimas tareas pendientes y en progreso</mat-card-subtitle>
        </div>
      </div>
    </mat-card-header>

    <mat-divider></mat-divider>

    <mat-card-content class="table-content">
      <ngx-spinner
        [zIndex]="100"
        name="spListado"
        bdColor="rgba(255,255,255,0.8)"
        size="default"
        color="var(--primary-color)"
        type="ball-atom"
        [fullScreen]="false">
      </ngx-spinner>

      <!-- Barra de herramientas -->
      <div class="toolbar" *ngIf="data">
        <div class="toolbar-left">
          <span class="data-count">
            <mat-icon>info</mat-icon>
            {{ dataSource.data.length }} tareas encontradas
          </span>
        </div>

        <div class="toolbar-right">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Buscar tareas</mat-label>
            <input
              matInput
              (keyup)="applyFilter($event)"
              placeholder="Título, expediente..."
              #input
            />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
      </div>

      <!-- Tabla responsive -->
      <div class="table-container" *ngIf="data">
        <table
          class="mat-elevation-z2"
          mat-table
          [dataSource]="dataSource"
          matSort
          matSortStart="asc"
        >
          <!-- Columna Título -->
          <ng-container matColumnDef="titulo">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              <strong>Título</strong>
            </mat-header-cell>
            <mat-cell *matCellDef="let tarea" class="titulo-cell">
              <div class="cell-content">
                <mat-icon class="cell-icon">task</mat-icon>
                <span class="cell-text">{{ tarea.titulo | titlecase }}</span>
              </div>
            </mat-cell>
          </ng-container>

          <!-- Columna Expediente -->
          <ng-container matColumnDef="expediente">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              <strong>Expediente</strong>
            </mat-header-cell>
            <mat-cell *matCellDef="let tarea" class="expediente-cell">
              <div *ngIf="tarea.expediente != null" class="expediente-link">
                <mat-icon class="cell-icon">folder</mat-icon>
                <a [routerLink]="'/expedientes/' + tarea.expediente.id" class="link-text">
                  {{ tarea.expediente.caratula | uppercase }}
                </a>
              </div>
              <span *ngIf="tarea.expediente == null" class="no-data">Sin expediente</span>
            </mat-cell>
          </ng-container>

          <!-- Columna Fecha Alta -->
          <ng-container matColumnDef="fechaAlta">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              <strong>Fecha Alta</strong>
            </mat-header-cell>
            <mat-cell *matCellDef="let tarea" class="fecha-cell">
              <div class="cell-content">
                <mat-icon class="cell-icon">schedule</mat-icon>
                <span class="cell-text">{{ tarea.fechaAlta | date : "short" }}</span>
              </div>
            </mat-cell>
          </ng-container>

          <!-- Columna Prioridad mejorada -->
          <ng-container matColumnDef="prioridad">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              <strong>Prioridad</strong>
            </mat-header-cell>
            <mat-cell *matCellDef="let tarea" class="prioridad-cell">
              <div class="priority-badge" [class]="'priority-' + tarea.prioridad">
                <mat-icon class="priority-icon">
                  {{ tarea.prioridad === 3 ? 'priority_high' :
                     tarea.prioridad === 2 ? 'remove' : 'low_priority' }}
                </mat-icon>
                <span>{{ getPrioridadTexto(tarea.prioridad) }}</span>
              </div>
            </mat-cell>
          </ng-container>

          <!-- Columna Acciones mejorada -->
          <ng-container matColumnDef="accion">
            <mat-header-cell *matHeaderCellDef>
              <strong>Acciones</strong>
            </mat-header-cell>
            <mat-cell *matCellDef="let tarea" class="action-cell">
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                aria-label="Acciones de la tarea"
                class="action-button"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item>
                  <mat-icon>visibility</mat-icon>
                  <span>Ver detalles</span>
                </button>
                <button mat-menu-item>
                  <mat-icon>edit</mat-icon>
                  <span>Editar</span>
                </button>
                <button mat-menu-item>
                  <mat-icon>check_circle</mat-icon>
                  <span>Marcar como completada</span>
                </button>
              </mat-menu>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row
            matRipple
            *matRowDef="let row; columns: displayedColumns"
            class="table-row">
          </mat-row>
        </table>
      </div>

      <!-- Estado sin datos -->
      <div class="no-data-state" *ngIf="!data || dataSource.data.length == 0">
        <div class="no-data-content">
          <mat-icon class="no-data-icon">search_off</mat-icon>
          <h3>No se encontraron tareas</h3>
          <p>No hay tareas que coincidan con los criterios de búsqueda.</p>
        </div>
      </div>

      <!-- Paginador -->
      <mat-paginator
        *ngIf="data && dataSource.data.length > 0"
        showFirstLastButtons
        class="paginator"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 20, 50]"
        [showFirstLastButtons]="true">
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
